<template>
  <div :style="$route.name === `patch-cord` ? `min-height: 500px` : `min-height: 580px`">
    <cable-side-indicator :invisible="overlay ? [...overlay.replace('side', '')] : []" v-if="displayCableSideIndicator"/>
    <product-canvas v-if="displayProductImage"
      :is-pigtail="isPigtail"
      :overlay="overlay"
      :override-product-width="overrideProductWidth"
      :thickness="thickness"
      :height="$route.name === 'patch-cord' ? 120 : 200"
    />

    <!-- <product-canvas
      :is-pigtail="isPigtail"
      :overlay="overlay"
      :override-product-width="overrideProductWidth"
      :thickness="thickness"
      style="position: absolute; left: 0px; top: 0; width: 100%"
      :height="$route.name === 'patch-cord' ? 120 : 200"
      :svg-id="`permaProduct`"
    /> -->
    <div 
      class="product-info mb-3" 
      :style="{ 'height' : overrideProductInfoHeight ? overrideProductInfoHeight : $route.name === 'patch-cord' ? `120px` : `200px`}" 
      v-html="$options.filters.breakify(productInfo)"
      v-if="displayProductInfo">
    </div>
    <slot name="pricing" v-if="displayProductInfo"></slot>
    <div
      class="w-100 d-flex justify-content-md-center mt-md-4" 
      v-if="displayCableLengthInput">
      <div
        class="w-100 text-secondary d-flex flex-column text-center align-items-md-center cable-length-label"
      >
        <div class="cable-length-row">
          <div class="cable-length bg-white pl-lg-2 pr-lg-4 flex-grow-1 flex-grow-md-0">
            <input
              :id="`cable-length-input-${configuratorStep}`"
              ref="cableLengthInput"
              type="number"
              :min="$route.name === 'patch-cord' ? 1 : $store.getters.cableLengthTrunk"
              v-model.lazy="formattedCableLength"
              style="border-color: #d7d7d7; width: 100px"
              class="cable-length border bg-light text-center rounded text-secondary mr-auto ml-n3 ml-md-0"
              :class="{
                'pulsating' : configuratorStep === 3,
                'invalid': lengthInvalid
              }"
              @change="validateLength"
            />
          </div>
          <label
            class="cable-length-text mb-0"
            :for="`cable-length-input-${configuratorStep}`"
          >
            {{ $t('cable-length') }}
          </label>
          <div class="cable-length-addon">
            <slot name="cable-length-addon" />
          </div>
        </div>
        <span v-if="configuratorStep === 3 || configuratorStep === 4"
          class="d-none d-md-block mt-1">
          {{ $t('cable-length-hint', [$route.name === 'patch-cord' ? 1 : new Intl.NumberFormat($i18n.locale === 'de' ? 'de-DE': 'en-US', {maximumFractionDigits: 2}).format($store.getters.minCableLengthTrunk), 300])}}</span>
      </div>
    </div>
    <!-- <hr class="border border-configurator d-block d-md-none" v-if="displayCableSideIndicator || displayProductImage || displayProductInfo || displayCableLengthInput"/> -->
    <configuration-options class="mt-2" v-bind="$props">
      <template v-slot:first>
        <slot name="first-column" />
      </template>

      <template v-slot:second>
        <slot name="second-column" />
      </template>

      <template v-slot:third>
        <slot name="third-column" />
      </template>

      <template v-slot:fourth>
        <slot name="fourth-column" />
      </template>
    </configuration-options>
    <slot name="default"></slot>
  </div>
</template>

<script>
import CableSideIndicator from "./CableSideIndicator";
import ConfigurationOptions from "./ConfigurationOptions";
import ProductCanvas from "./ProductCanvas";

export default {
  data () {
    return {
      lengthInvalid: false
    }
  },
  components: {
    CableSideIndicator,
    ConfigurationOptions,
    ProductCanvas
  },
  props: {
    layout: {
      type: String,
      default: "2-columns"
    },
    isPigtail: {
      type: Boolean,
      default: false
    },
    overlay: {
      type: String,
      default: null
    },
    thickness: {
      type: String,
      default: null
    },
    overrideProductWidth: {
      type: Boolean,
      default: false
    },
    load: {
      type: Function,
      default: () => {}
    },
    configuratorStep: {
      type: Number,
      default: 0
    },
    displayCableSideIndicator: {
      type: Boolean,
      default: true
    },
    displayCableLengthInput: {
      type: Boolean,
      default: true
    },
    displayProductImage: {
      type: Boolean,
      default: true
    },
    displayProductInfo: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'productImage',
      validator: (val) => ['productImage', 'productInfo'].includes(val)
    },
    productInfo: {
      type: String,
      default: ''
    },
    overrideProductInfoHeight: {
      type: String,
      default: null
    }
  },
  mounted() {
    if (this.load) this.load();
    // try {
    //   // maybe it's not present, like on mobile
    //   if (this.configuratorStep === 3 || this.configuratorStep === 4) 
    //     this.$refs.cableLengthInput.focus()
    // } catch (_) {
    //   // do nothing
    // }
  },
  methods: {
    validateLength ( $event ) {
      if (parseFloat($event.target.value) < (this.$route.name === 'patch-cord' ? 1 : this.$store.getters.cableLengthTrunk) || $event.target.value == ''){
        this.$store.state.cableLength = this.$route.name === 'patch-cord' ? 1 : this.$store.getters.cableLengthTrunk
        this.lengthInvalid = true
      }
      this.lengthInvalid = false
    }
  },
  computed: {
    formattedCableLength: {
      get () {
        let cl = new Intl.NumberFormat(
          this.$i18n.lcale === 'de'
            ? 'de-DE'
            : 'en-US',
          { style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 1})
            .format(
              parseFloat(this.$store.state.cableLength).toFixed(1))
        return cl
      },
      set (value) {
        value = parseFloat(value.replace(',', '.'))
        if (value && value <= 300)
          this.$store.commit('setState', { stateKey: 'cableLength', data: value })
      }
    }
  }
};
</script>

<style lang="scss">
.cable-length-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  justify-content: center;
}

.cable-length-addon {
  display: flex;
  align-items: center;
}

.cable-length-text {
  white-space: nowrap;
}

.cable-length::after {
  content: "m";
  margin-left: -2em;
}
input.cable-length:focus {
  box-shadow: 0 0 0 0 rgba($saka-orange, 1);
  animation: pulse 1.5s 5;
}

input.cable-length {
  animation: none;
}

.cable-length:focus {
  outline-color: $saka-orange;
}

input.cable-length.invalid {
  box-shadow: 0 0 0 5px rgba(#d60101, .5);
}

@keyframes pulse {
  60% {
    box-shadow: 0 0 0 10px rgba($saka-orange, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba($saka-orange, 0);
  }
}

input.cable-length::-webkit-outer-spin-button,
input.cable-length::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input.cable-length[type=number] {
  -moz-appearance: textfield;
}

@media (max-width: 768px) {
  .cable-length-row {
    flex-direction: column;
    align-items: stretch;
  }

  .cable-length-text {
    text-align: center;
  }

  .cable-length-addon {
    width: 100%;
    justify-content: center;
  }

  .cable-length {
    margin-left: -3em !important;
  }
}

@media (min-width: 768px) and (max-width: 992px) {
  .cable-length {
    margin-left: -1em !important;
  }
}

.product-info {
  overflow-y: auto;
}
</style>
